













import { defineComponent, PropType } from '@vue/composition-api';
import { mapGetters } from 'vuex';
import { IInvoice } from '@/models';
import { IInvoiceStateVisual } from '@/store/invoice';

export default defineComponent({
  name: 'InvoiceStatusDisplay',

  props: {
    invoice: { type: Object as PropType<IInvoice>, required: true }
  },

  computed: {
    ...mapGetters({
      getInvoiceStateVisualByState: 'invoice/getInvoiceStateVisualByState'
    }),

    invoiceState(): IInvoiceStateVisual {
      return this.getInvoiceStateVisualByState(this.invoice.state);
    }
  }
});
